export function callIfExists<T extends any[], R>(
	callback: ((...args: T) => R) | undefined | null,
): (...args: T) => R | undefined {
	return (...args: T) => {
		if (callback != null) {
			return callback(...args);
		}
		return undefined;
	};
}
